import React from 'react';
import { DashboardWidgetComponent } from '../../interfaces/DashboardWidgetComponent';
import { ViewDataTable } from '../../../shared/entities/view/components/view/interfaces/api/ViewDataTable';
import DashboardTable from './shared/DashboardTable';

const DashboardNewFilingsWidget: DashboardWidgetComponent<ViewDataTable> = props => {
  return (
    <DashboardTable
      dataTable={props.data}
      widgetType={'NewFilings'}
      width={props.dimensions?.width}
      isCompanyNameTitleEllipsis={true}
      pinTickerColumn
    />
  );
};

export default DashboardNewFilingsWidget;
